import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { CompareArrowsRounded } from '@mui/icons-material';

type ActionResponse = { netProfileId: string }[];
type ActionArgs = { privateProfileId?: string };

export type AndieGetProfileCompetitorsProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieGetProfileCompetitors = (props: AndieGetProfileCompetitorsProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.get-profile-competitors.title')}
            icon={<CompareArrowsRounded fontSize="small" />}
            privateProfileId={props.args?.privateProfileId}
            loadingMessages={() => [t('andie.tool.get-profile-competitors.loading')]}
            completeMessage={({ result }) =>
                t('andie.tool.get-profile-competitors.complete', {
                    value: result && Array.isArray(result) ? result.length : 0,
                })
            }
            {...props}
        />
    );
};

export default AndieGetProfileCompetitors;
